export const list = [
    {
        name:'Tribal Lady',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/tribal_lady.png',
        description:'Himba tribal community is very unique and has inspired many women across globe as these women tend' +
            ' to perform more labor-intensive work than men. Their appearance of rich dark skin and jewelleries make ' +
            'them standout from the contemporary tribal communities.\n',
        price:2000.00
    },
    {
        name:'Bindhu & Bhavani',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/bindu_bhavani.png',
        description:'This is my first hyper-realistic drawing on a large scale, which took one year to complete. ' +
            'The subjects here are good friends of mine who were ready to pose for me. ' +
            'Both are very talented and hard-working women and have inspired me to start portrait series. ' +
            'The source of inspiration in this artwork is the real wave of emotions and expressions as seen ' +
            'through an eye of an artist.\n',
        price:2000.00
    },
    {
        name:'Trans Life',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/trans_series.png',
        description:'I had the pleasure of meeting this beautiful trans lady in the suburbs of Hyderabad in December ' +
            '2018. After getting to know her story my whole perspective on trans community has changed completely.' +
            ' She was thrown out of her family as a kid to living as an outcast in suburbs and struggling to earn ' +
            'a living.\n',
        price:2000.00
    },
    {
        name:'Abstract Face',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/blue.png',
        description:'It\'s a fusion of Charcoal abstract and Realism. As I have been working on realism for quite a ' +
            'few years, I wanted to create art while experimenting with both forms.\n',
        price:2000.00
    },
    {
        name:'Acrylics on canvas',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/abstract.png',
        description:'Acrylics on canvas',
        price:2500.00
    },{
        name:'Pride',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/pride.png',
        description:'To those who love; same and different gender as theirs, same and different sexuality as theirs; ' +
            'same and different faces as theirs; same and different characters as theirs, you are NOT alone. ' +
            'When a single human being is deprived of loving someone who doesn\'t fit into their \'opposite gender\' ' +
            'category, know that it is love too. Loving someone from all your heart doesn\'t need any categories or' +
            ' specifications. It is the beautiful heart of your partner and the partners you fall for. Be proud and ' +
            'stand strong! This artwork is dedicated to everyone and the LGBTQ+ community. To tell them, that we love you! We are proud of you! And that without you all, the world would have not been a better place.\n' +
            '💜💙💚💛🧡❤️\n' +
            '\n',
        price:2000.00
    },
    {
        name:'Sad Eyes',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/sad_eyes.png',
        description:'- Mix media\n' +
            '- Red eye represent sadness\n' +
            '- Sorrow of life can be seen in eyes\n',
        price:2500.00
    },
    {
        name:'Dark Heart',
        type:'Portrait',
        imgUrl: window.location.origin + process.env.PUBLIC_URL+'/images/store/dark_heart.png',
        description:"This painting is an analogy to a poem that a poet creates out of his/her darkness. Emotion is all " +
            "we have as human beings and the heart is a place for that. This artwork shows the emotions of a lifeless poet.",
        price:2500.00
    },
]